import React from 'react';

const LeaderboardSection = () => {
  const features = [
    {
      number: "01",
      title: "Top Builds Ranked Weekly",
      description: "Rides are ranked based on challenge performance, votes, and engagement metrics."
    },
    {
      number: "02", 
      title: "Challenge Performance Tracking",
      description: "See standings from \"Challenge My Ride\" categories such as stance, power, and customization."
    },
    {
      number: "03",
      title: "Achievements and Badges", 
      description: "Users earn badges, titles, and profile highlights as they progress on the leaderboard."
    },
    {
      number: "04",
      title: "Local and Global Rankings",
      description: "View rankings within your city or compete for visibility on the global leaderboard."
    }
  ];

  return (
    <>
      <style>{`
        @media (max-width: 468px) {
          #about {
            margin-bottom: 5rem !important;
          }
        }
      `}</style>
      <section  className="bg-[#0B0B0B] text-white pb-12 md:pb-16 lg:pb-24 pt-0 px-0 sm:px-8 md:px-10 lg:px-16 xl:px-24 md:-mt-16 lg:-mt-28 2xl:px-32 2xl:-mt-10 sm:-mt-32 relative overflow-hidden xxs:-mt-32 mt-8 w-full">
      {/* Background decorative elements - stars/glints */}
      {/* <div className="absolute top-0 left-0 w-32 h-32 opacity-20 pointer-events-none">
        <div className="absolute top-8 left-8 w-2 h-2 bg-white rounded-full"></div>
        <div className="absolute top-12 left-16 w-1 h-1 bg-white rounded-full"></div>
        <div className="absolute top-16 left-12 w-1.5 h-1.5 bg-white rounded-full"></div>
      </div>
      <div className="absolute bottom-0 right-0 w-32 h-32 opacity-20 pointer-events-none">
        <div className="absolute bottom-8 right-8 w-2 h-2 bg-white rounded-full"></div>
        <div className="absolute bottom-12 right-16 w-1 h-1 bg-white rounded-full"></div>
        <div className="absolute bottom-16 right-12 w-1.5 h-1.5 bg-white rounded-full"></div>
      </div> */}

      {/* Main Container */}
      {/* <div className="max-w-7xl mx-auto mt-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16"> */}
          
          {/* Left Section: Leaderboard Champion */}
          {/* <div className="w-full relative -ml-4 md:-ml-6 lg:-ml-8 xl:-ml-24"> */}
            {/* Background box behind the entire section */}
            {/* <div 
                style={{
                  position: 'absolute',
                  top: 0,
                  left:'14%',
                  right: 0,
                  width: '80%',
                  height: '80px',
                  background: 'linear-gradient(to bottom, rgba(194, 65, 12, 0.2), rgba(194, 65, 12, 0.3), transparent)',
                  borderRadius: '24px 24px 0 0',
                  pointerEvents: 'none',
                  zIndex: 1,
                  opacity: 0.9,
                  filter: 'blur(60px)'
                }}
              ></div>
            <div 
              className="absolute rounded-2xl lg:rounded-3xl"
              style={{
                top: 0,
                left: '-80px',
                right: '-120px',
                bottom: 0,
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0) 100%)',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                zIndex: 0
              }}
            />
            
            <div className="relative z-10 px-6 md:px-8 lg:px-8 pt-8 lg:pt-16 pb-0 flex flex-col items-center transform lg:scale-90 xl:scale-95">
              <h2 
                className="text-3xl md:text-4xl lg:text-5xl xl:text-4xl  font-semibold text-white uppercase tracking-wider mb-8 lg:mb-12 font-noto-sans leading-relaxed text-center"
                style={{ transform: 'scaleY(1.4)' }}
              >
                LEADERBOARD CHAMPION
              </h2>
              
              <div className="relative bg-[#0B0B0B] rounded-2xl lg:rounded-3xl p-6 md:p-8 lg:p-7 shadow-2xl backdrop-blur-sm border-l-4 border-[#FFA500] w-[96%] sm:w-[92%] md:w-[88%] lg:w-[84%] xl:w-[90%] flex flex-col items-center -ml-2 md:ml-0 lg:-ml-2 main-box"> */}
                {/* Trophy image in right bottom corner */}
                {/* <div className="absolute bottom-0 right-0 transform translate-x-4 sm:translate-x-8 md:translate-x-12 lg:translate-x-16 xl:translate-x-48 translate-y-4 sm:translate-y-8 md:translate-y-10 lg:translate-y-12 xl:translate-y-1 w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 xl:w-72 xl:h-72 opacity-90 pointer-events-none block z-20 trophy-image">
                  <img 
                    src="/asset/trophy.png" 
                    alt="Trophy" 
                    className="w-full h-full object-contain"
                    style={{
                      filter: 'drop-shadow(0 4px 8px rgba(255, 165, 0, 0.3))'
                    }}
                  />
                </div> */}
              
           
             
              
              {/* Header with Badge and Button */}
              {/* <div className="relative mb-6 w-full flex flex-col items-center"> */}
                {/* Background box behind the header */}
                {/* <div 
                style={{
                  position: 'absolute',
                  top: 0,
                  left:'-20%',
                  right: 0,
                  width: '60%',
                  height: '80px',
                  background: 'linear-gradient(to right, rgba(194, 65, 12, 0.2), rgba(194, 65, 12, 0.3), transparent)',
                  borderRadius: '24px 24px 0 0',
                  pointerEvents: 'none',
                  zIndex: 1,
                  opacity: 0.9,
                  filter: 'blur(60px)'
                }}
              ></div>
                <div 
                  style={{
                    position: 'absolute',
                    top: '14px',
                    left: '8px',
                    right: '8px',
                    bottom: '14px',
                    background: '#FFFFFF05',
                    borderRadius: '16px',
                    borderBottom: '1.61px solid',
                    borderImageSource: 'linear-gradient(90deg, rgba(244, 76, 29, 0) 0%, rgba(244, 76, 29, 0.3) 50%, rgba(244, 76, 29, 0) 100%)',
                    borderImageSlice: 1,
                    zIndex: 0
                  }}
                ></div> */}
                
                {/* <div className="flex flex-col sm:flex-row justify-center items-center gap-4 p-4 relative z-10 w-full"> */}
                  {/* Badge - Hexagonal */}
                  {/* <div className="flex items-center gap-3 text-white px-4 py-2 md:px-5 md:py-3 xl:px-8 xl:py-4 relative z-20 -ml-2 md:-ml-4">
                    <div className="relative w-8 h-8 md:w-8 md:h-8 xl:w-10 xl:h-10 flex items-center justify-center flex-shrink-0"> */}
                      {/* Medal image */}
                      {/* <img 
                        src="/asset/Medal.png" 
                        alt="Medal" 
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <span className="font-bold text-sm md:text-base xl:text-2xl text-yellow-600 font-noto-sans whitespace-nowrap">1st On Leaderboard</span>
                  </div> */}
                  
                  {/* Challenge Now Button - Outlined */}
                  {/* <button className="border-2 border-[#FF4D00] hover:border-[#FF6A00] text-orange-600 bg-transparent px-2 py-1.5 md:px-6 md:py-1.5 rounded-2xl font-semibold text-xs md:text-sm xl:text-lg transition-all duration-300 font-noto-sans whitespace-nowrap -ml-6 md:-ml-8">
                    Challenge Now
                  </button>
                </div>
              </div> */}
              
              {/* Car Image */}
              {/* <div className="mb-8 relative w-full">
                <div className="relative w-full h-auto flex justify-center items-center">
                  <img 
                    src="/asset/leaderboard.png" 
                    alt="Mercedes AMG GT Black Series" 
                    className="h-auto object-contain rounded-xl"
                    style={{
                      minHeight: '180px',
                      maxHeight: '540px',
                      width: '108%',
                      transform: 'scale(1.08)',
                      marginLeft: '6%',
                     translateX:'(3%)',
                    }}
                  />
                  <style>{`
                    @media (min-width: 768px) and (max-width: 1023px) {
                      .main-box {
                        width: 95% !important;
                        transform: scale(0.95) !important;
                        margin-left: 0 !important;
                      }
                    }
                  `}</style>
                </div>
              </div> */}
              
              
              {/* Car Details */}
              {/* <div className="space-y-2 md:space-y-3 relative z-10 pt-0 mt-0 w-full flex flex-col items-start">
             
              <div 
                className="flex items-center justify-center mb-1 mt-6 cursor-pointer -pb-1 max-w-[60%]"
                style={{
                  borderBottom: '1.61px solid',
                  borderImageSource: 'linear-gradient(90deg, #F44C1D 0%, rgba(244, 76, 29, 0) 100%)',
                  borderImageSlice: 1,
                }}
              >
                    <h3 className="text-white text-xl md:text-2xl xl:text-2xl font-semibold font-noto-sans">Car Details</h3>
                   
                  </div>
                  
                  <div className="grid grid-cols-2 gap-2 md:gap-4 w-full max-w-md"> */}
                    {/* Row 1 */}
                    {/* <div className="flex flex-row items-center pb-2 border-b border-gray-700">
                      <span className="text-gray-200 text-sm md:text-base xl:text-xl font-regular font-noto-sans text-left">Year</span>
                      <span className="text-white text-base md:text-lg xl:text-base font-medium font-noto-sans text-left ml-8 xl:ml-20 md:ml-5">2021-2022</span>
                    </div>
                    
                    <div className="flex flex-row items-center pb-2 border-b border-gray-700 ml-2 md:ml-4 lg:ml-16">
                      <span className="text-gray-200 text-sm md:text-base xl:text-xl font-regular font-noto-sans text-left">Make</span>
                      <span className="text-white text-base md:text-lg xl:text-base font-medium font-noto-sans text-left ml-8 xl:ml-6 xl:whitespace-nowrap md:ml-5">MERCEDES-BENZ</span>
                    </div> */}
                    
                    {/* Row 2 */}
                     {/* <div className="flex flex-row items-center pt-2 pb-0">
                     <span className="text-gray-200 text-sm md:text-base xl:text-xl font-regular font-noto-sans text-left">Engine</span>
                      <span className="text-white text-base md:text-lg xl:text-base font-medium font-noto-sans text-left ml-8 xl:mr-1 md:ml-5 xl:whitespace-nowrap">4.0L Twin-Turbo V8</span>
                    </div>
                    
                    <div className="flex flex-row items-center pt-2 ml-2 md:ml-4 lg:ml-16 relative">
                      <span className="text-gray-200 text-sm md:text-base xl:text-xl font-regular font-noto-sans text-left">Model</span>
                      <span className="text-white text-base md:text-lg xl:text-base font-medium font-noto-sans text-left ml-8 xl:ml-6 xl:whitespace-nowrap md:ml-5">AMG GT Black Series</span>
                    </div>
                      
                  </div>
                </div>
              </div>
            </div> */}
           
          {/* </div> */}
          <div className="max-w-7xl mx-auto mt-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center">
          {/* Left Section: Champion Image */}
          <div className="w-full flex justify-start lg:justify-end">
            <div className="relative w-full max-w-[95vw] sm:max-w-[90vw] md:max-w-[720px] lg:max-w-[960px] lg:max-h-[820px] xl:max-w-[1080px] 2xl:max-w-[1120px] rounded-3xl px-4 sm:px-6 md:px-10 lg:px-0 transform md:translate-x-6 lg:-translate-x-8 xl:-translate-x-10 2xl:-translate-x-24">
              <img
                src="/asset/lg.png"
                alt="Leaderboard Champion Ride"
                className="w-full h-auto object-contain rounded-3xl transform scale-[1.25] sm:scale-[1.1] md:scale-[1.05] lg:scale-[1.15] xl:scale-[1.25] 2xl:scale-[1.3]"
                loading="lazy"
              />
            </div>
          </div>
          {/* Right Section: Ride Performance Leaderboard */}
          <div className="w-full flex flex-col justify-center 2xl:-ml-14 xl:-ml-1 lg:-ml-10">
            <div className="mb-2 lg:mb-10 sm:mt-10 ">
                <div className="flex flex-wrap sm:flex-row sm:items-center gap-1 md:gap-2 mb-2 md:mb-4">
                <h2 className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl font-semibold text-white uppercase tracking-wider font-noto-sans leading-tight" style={{ transform: 'scaleY(1.3)' }}>
                  RIDE
                </h2>
                <h2 className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl font-semibold text-white uppercase tracking-wider font-noto-sans leading-tight" style={{ transform: 'scaleY(1.3)' }}>
                  PERFORMANCE
                </h2>
                <h2 className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl font-semibold text-orange-700 uppercase tracking-wider font-noto-sans leading-tight" style={{ transform: 'scaleY(1.3)' }}>
                  LEADERBOARD
                </h2>
              </div>
              <p className="text-gray-200 text-sm md:text-base lg:text-lg font-noto-sans leading-relaxed max-w-2xl ">
                Compete, rank, and gain recognition in the car community.
              </p>
            </div>
            
            <div className="space-y-4 md:space-y-6 lg:space-y-3 ">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="flex w-full items-start gap-3 md:gap-4 lg:gap-5 pb-1 md:pb-4"
                    style=
                      {index < features.length - 1
                        ? {
                            borderBottom: '1px solid #FFFFFF0D',
                            marginRight: '-56px',
                            paddingRight: '56px'
                          }
                        : {}}
                  >
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 md:w-8 md:h-8 lg:w-8 lg:h-8 rounded flex items-center justify-center aspect-square" style={{ backgroundColor: '#141415', border: '1px solid #FFFFFF0D' }}>
                      <span className="text-white font-bold text-[11px] md:text-xs lg:text-xs font-oswald">
                        {feature.number}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-white-500 opacity-8 text-base md:text-lg lg:text-base font-regular mb-2 md:mb-3 font-noto-sans leading-tight 2xl:whitespace-nowrap break-words">
                      {feature.title}
                    </h3>
                    <p className="text-gray-200 text-xs md:text-sm lg:text-base font-regular leading-relaxed font-noto-sans 2xl:whitespace-nowrap break-words whitespace-normal">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default LeaderboardSection;

